import { render, staticRenderFns } from "./IconMarker.vue?vue&type=template&id=aa8cf196&scoped=true&"
import script from "./IconMarker.vue?vue&type=script&lang=js&"
export * from "./IconMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8cf196",
  null
  
)

export default component.exports